import TestModal from "./TestModal";
import { toast } from "react-toastify";
import { useRecoilValue } from "recoil";
import ModalLayout from "./ModalLayout";
import MUIDataTable from "mui-datatables";
import { Box, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import { Button, Grid } from "@mui/material";
import { IconTestPipe } from "@tabler/icons";
import EditIcon from "@mui/icons-material/Edit";
import { configState } from "../../../recoil/atoms";
import LinearProgress from "@mui/material/LinearProgress";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { Tests, TestsApi } from "../../../api/medical-operations";
import MainCard from "../../../styles/ui-component/cards/MainCard";
import ConfirmDialog from "../../../utils/FormFields/ConfirmDialog";
import useAuthorization from "../../Authentication/permissions/Authorization";

export default function MedicalTests() {
  const config = useRecoilValue(configState);

  const [testName, setTestName] = useState("");
  const [rowID, setRowID] = useState<string>("");
  const [tests, setTests] = useState<Tests[]>([]);
  const [editModal, setEditModal] = useState<Tests>();
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState<boolean>(false);

  const { canGetTests, canEditTests, canAddTests, canDeleteTests } = useAuthorization();

  const handleOpenModal = () => setOpenModal(true);

  const handleCloseModal = () => {
    setOpenModal(false);
    setIsEdit(false);
    setEditModal(undefined);
    getTests();
  };

  const getTests = () => {
    const Tests = new TestsApi(config);
    Tests.getTests()
      .then((res) => {        
        setTests(res?.data);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getTests();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleDelete = (id: string) => {
    setRowID(id);
    handleOpenDialog();
  };

  const handleConfirm = () => {
    deleteTests(rowID);
    handleCloseDialog();
  };

  const deleteTests = (id: string) => {
    const Tests = new TestsApi(config);
    Tests.deleteTests(id)
      .then((res) => {
        getTests();
        toast.success(res?.data?.Message!);
      })
      .catch((err) => {
        toast.error(err?.response?.data?.detail);
      });
  };

  const columns = [
    {
      name: "TestID",
      options: {
        display: false,
        filter: false,
        print: false,
        download: false,
      },
    },
    {
      name: "Code",
      label: "Code",
    },
    {
      name: "Name",
      label: "Name",
    },

    {
      name: "Price",
      label: "Price",
    },
    {
      name: "action",
      label: "Action",
      print: false,
      options: {
        filter: false,
        sort: false,
        print: false,
        download: false,
        setCellHeaderProps: () => ({ align: "center" }),
        setCellProps: () => ({ align: "center" }),
        customBodyRender: (value: any, tableMeta: any, updateValue: any) => (
          <>
            {canEditTests && (
              <Tooltip title="Edit">
                <Button
                  variant="outlined"
                  color="secondary"
                  onClick={() => {
                    setEditModal(tableMeta.tableData[tableMeta.rowIndex]);
                    setIsEdit(true);
                    handleOpenModal();
                  }}
                >
                  <EditIcon color="secondary" />
                </Button>
              </Tooltip>
            )}
            {canDeleteTests && (
              <Tooltip title="Delete">
                <Button
                  variant="outlined"
                  color="error"
                  sx={{
                    ml: { xs: 0, xl: 2 },
                  }}
                  onClick={() => {
                    handleDelete(tableMeta.rowData[0]);
                    setTestName(tableMeta.rowData[2]);
                  }}
                >
                  <DeleteOutlineIcon color="error" />
                </Button>
              </Tooltip>
            )}
          </>
        ),
      },
    },
  ];

  return (
    <>
      {canGetTests && (
        <MainCard>
          <Grid>
            {!isLoading ? (
              <>
                <Modal
                  open={openModal}
                  onClose={handleCloseModal}
                  style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                >
                  <Box>
                    <ModalLayout>
                      <TestModal handleCloseModal={handleCloseModal} editTest={editModal} isEdit={isEdit} />
                    </ModalLayout>
                  </Box>
                </Modal>
                <MUIDataTable
                  data={tests}
                  columns={columns}
                  options={{
                    filter: true,
                    viewColumns: false,
                    selectableRows: "none",
                    selectableRowsOnClick: false,
                    elevation: 0,
                    rowsPerPage: 10,
                    filterType: "dropdown",
                    enableNestedDataAccess: ".",
                    responsive: "standard",
                    customToolbar: () => {
                      return (
                        canAddTests && (
                          <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<IconTestPipe />}
                            onClick={handleOpenModal}
                            sx={{
                              ml: "50px",
                            }}
                          >
                            Add Test
                          </Button>
                        )
                      );
                    },
                  }}
                  title=""
                />
                <ConfirmDialog
                  name={"test"}
                  record={testName}
                  handleCloseDialog={handleCloseDialog}
                  handleConfirm={handleConfirm}
                  openDialog={openDialog}
                />
              </>
            ) : (
              <LinearProgress color="secondary" />
            )}
          </Grid>
        </MainCard>
      )}
    </>
  );
}
